module.exports = __webpack_public_path__ + "static/img/thumb_clippers.28cc742.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/certificates/thumb_clippers.jpg
// module id = 37
// module chunks = 0